export const TILE_CONFIG = {
  TILE_WIDTH: 50,
  TILE_HEIGHT: 50,
};

export const WALL_CONFIG = {
  WALL_HEIGHT_TOP: 300,
  THICKNESS: 20,
  BOTTOM_WALL_THICKNESS_FIRST: 16,
  BOTTOM_WALL_THICKNESS_SECOND: 12,
  LINE_THICKNESS: 2,
  PRIMARY_COLOR: "825641",
  SECONDARY_COLOR: "503929",
  TERTIARY_COLOR: "29160f",
};

export const WALL_COLORS = [
  "29160f", // Dark color
  "a9a3a0", // Light color
  "39FF14", // Neon Green
  "FF073A", // Neon Red
  "00FFFF", // Neon Cyan
  "FF1493", // Neon Pink
  "FFFF00", // Neon Yellow
  "FF4500", // Neon Orange
];

export const TILE_COLORS = [
  "1f0d07", // Darker shade of brown
  "6b5b5a", // Dark muted beige
  "2a2a2a", // Dark Gray
  "5a2d2f", // Dark Red
  "004d4d", // Dark Cyan
  "9b006e", // Dark Pink
  "7f7f00", // Dark Yellow-Green
  "8b2b16", // Dark Orange
];

export const FURNITURE_SITTABLE = ["red_couch", "stool", "american_chair"];

export const WALL_PATTERNS = [
  "horizontal_stripe.png",
  "vertical_stripe.png",
  "vertical_stripe2.png",
  "diagnol_stripe.png",
  "heart.png",
  "flowers.png",
  "bricks.png",
  "dots.png",
];

export const gameConfig = {
  default: {
    look: "sk(4287f5)-bd(male)-ts(tanktop:ffffff)-hr(mohawk:4287f5)-lg(pants:0000FF)",
    position: { x: 1, y: 1 },
  },
};
